import { qwanyxCollection } from "qwanyx";

export async function getBatch(
    query = {},
    page = 1,
    limit = 20,
    projection = {},
    sort = {}
) {
    console.log('getBatch called with:', { query, page, limit, projection, sort });
    
    try {
        const skip = (page - 1) * limit;
        const collection = qwanyxCollection();
        
        const options = {
            limit: limit,
            skip: skip
        };
        
        // Add projection if provided
        if (Object.keys(projection).length > 0) {
            options.projection = projection;
        }
        
        // Get data without sorting from Realm
        const batch = await collection.find(query, options);
        
        if (!Array.isArray(batch)) {
            console.warn('Expected array from Realm but got:', typeof batch);
            return [];
        }
        
        // Apply client-side sorting if sort parameter is provided
        if (Object.keys(sort).length > 0) {
            console.log('Applying client-side sorting:', sort);
            
            // Sort the batch
            batch.sort((a, b) => {
                // Handle each sort field
                for (const [field, direction] of Object.entries(sort)) {
                    if (a[field] === undefined || b[field] === undefined) continue;
                    
                    // String comparison
                    if (typeof a[field] === 'string' && typeof b[field] === 'string') {
                        const comparison = a[field].localeCompare(b[field]);
                        if (comparison !== 0) return comparison * direction;
                    } 
                    // Number/Date comparison
                    else if (a[field] < b[field]) {
                        return -1 * direction;
                    } else if (a[field] > b[field]) {
                        return 1 * direction;
                    }
                }
                return 0;
            });
        }
        
        return batch;
    } catch (error) {
        console.error("Error fetching batch:", error);
        throw error;
    }
}